import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import AddPatent from '../../components/AddPatent';

import WizardLayout from '../../components/WizardLayout';
import useWizardSteps from '../../hooks/useWizardSteps';
import WizardNavigation from '../../components/WizardNavigation';

import { Grid } from '@material-ui/core';

import { getInsuranceLocalInfo } from '../../utils';

import './style.scss';

const suggestion = (
  <span>
    <b>Completa los datos de tu auto</b> para continuar
  </span>
);

export default function Patente() {
  const [nextWasRequired, setNextWasRequired] = useState(false);
  const history = useHistory();
  const [activeStep] = useWizardSteps(3);

  const { isValidCarPatent, insuranceName } = useSelector(
    ({ carInsurance, insurances }) => ({
      insuranceName: insurances.selected.insuranceName,
      isValidCarPatent:
        carInsurance.userCarInsurance && carInsurance.isValidPatent,
    })
  );

  const insuranceInfo = getInsuranceLocalInfo(insuranceName);

  const nextAction = () => {
    if (isValidCarPatent) {
      //history.push(`${insuranceInfo.url}/domicilio`);
      history.push(`/domicilio/nuevo`);
    }
    setNextWasRequired(true);
    return;
  };

  return (
    <WizardLayout activeStep={activeStep} suggestion={suggestion}>
      <Grid item xs={11} sm={12} container justify='center'>
        <AddPatent nextWasRequired={nextWasRequired} />
        <WizardNavigation nextAction={nextAction} />
      </Grid>
    </WizardLayout>
  );
}
